var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreSettingsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3623 16.9125C23.515 16.9125 24.5294 16.2821 25.0519 15.3289L30.5542 5.3505C31.1228 4.33575 30.3851 3.075 29.217 3.075H6.47047L5.02576 0H0V3.075H3.07386L8.6068 14.7446L6.53195 18.4961C5.40999 20.5564 6.88544 23.0625 9.22158 23.0625H27.6647V19.9875H9.22158L10.9122 16.9125H22.3623ZM7.93055 6.15H26.6042L22.3623 13.8375H11.5731L7.93055 6.15ZM9.22158 24.6C7.53095 24.6 6.16309 25.9838 6.16309 27.675C6.16309 29.3663 7.53095 30.75 9.22158 30.75C10.9122 30.75 12.2954 29.3663 12.2954 27.675C12.2954 25.9838 10.9122 24.6 9.22158 24.6ZM24.5909 24.6C22.9002 24.6 21.5324 25.9838 21.5324 27.675C21.5324 29.3663 22.9002 30.75 24.5909 30.75C26.2815 30.75 27.6647 29.3663 27.6647 27.675C27.6647 25.9838 26.2815 24.6 24.5909 24.6Z",
    fill: "url(#paint0_linear_14_812)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_812",
    x1: 6,
    y1: 6,
    x2: 31,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43C9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57D737"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreSettingsIcon);
export default __webpack_public_path__ + "static/media/storeSettingsIcon.94329428.svg";
export { ForwardRef as ReactComponent };